import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const TopBanner = ({ mainTopImage }) => {
  const [extractedLink, setExtractedLink] = useState("");
  const [ecardLink, setEcardLink] = useState("");

  // // console.log(mainTopImage);
  // useEffect(() => {
  //   const htmlString = `${mainTopImage}`;

  //   // Regular expression to match the src attribute in an img tag
  //   const srcRegex = /<img\s+[^>]*src="([^"]*)"[^>]*>/;
  //   const srcMatch = htmlString.match(srcRegex);
  //   const srcAttribute = srcMatch ? srcMatch[1] : null;

  //   // Regular expression to match the href attribute in an <a> tag
  //   const hrefRegex = /<a\s+[^>]*href="([^"]*)"[^>]*>/;
  //   const hrefMatch = htmlString.match(hrefRegex);
  //   const ecardLink = hrefMatch ? hrefMatch[1] : null;

  //   // Set the extracted links in state or wherever you need them
  //   setExtractedLink(srcAttribute);
  //   setEcardLink(ecardLink);
  // }, [mainTopImage]); // just enable this if you need to set the image from the api

  return (
    <Grid
      container
      size={12}
      sx={{ width: "100%", height: "100px" }}
      justifyContent={"center"}
    >
      <Grid item size={12} sx={{ width: "100%" }}>
        <Link to={ecardLink} style={{ textDecoration: "none" }}>
          <img
            src={mainTopImage}
            style={{
              width: "100%",
              height: "100px",
              backgroundRepeat: "no-repeat",
              objectFit: "contain", // disable this if img need to be 100% of the scree, but need wider img file.
            }}
          />
        </Link>
      </Grid>
    </Grid>
  );
};

export default TopBanner;
